import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Typography from '@material-ui/core/Typography'

interface InlineErrorProps {
  i18nErrorId: string
}

const InlineError = ({ i18nErrorId }: InlineErrorProps) => (
  <Typography color={'error'}>
    <FormattedMessage id={i18nErrorId} />
  </Typography>
)

export default InlineError



// WEBPACK FOOTER //
// ./src/components/atoms/InlineError.tsx